<mat-form-field class="dynamicForm_alignment" [formGroup]="group">
  @if (field.description) {
    <p [innerHTML]="field.description"></p>
  }
  <mat-label>{{field.labelName}}</mat-label>
  <mat-select [formControlName]="field.labelCode" [required]="isRequired">
    @for (item of sortedOptions; track item) {
      <mat-option [value]="item.code"
        [disabled]="item.isActive != undefined && !item.isActive">
        {{item.value}}
      </mat-option>
    }
  </mat-select>
  @for (validation of field.validations; track validation) {
    <ng-container ngProjectAs="mat-error">
      @if (group.get(field.labelCode).hasError(validation.name.toLocaleLowerCase()) && !(group.get(field.labelCode).hasError(required))) {
        <mat-error>{{validation.message}}</mat-error>
      }
      @if (group.get(field.labelCode).hasError(required)) {
        <mat-error>{{field.labelName}} is mandatory</mat-error>
      }
    </ng-container>
  }
</mat-form-field>
